import { Avatar, Button, Chip, Dialog, DialogActions, DialogContent, Divider, Fab, Grid } from '@material-ui/core';
import React, { createRef } from 'react';
import CustomUserMenu from '../../commons/CustomUserMenu';
import Utils from '../../providers/Utils';
import ChartsChestionare from './ChartsChestionare';
import { ReactComponent as SignInSolid } from './Icoane Font Awesome/sign-in-alt-solid.svg'
import ListaEvaluatoriAll from './ListaEvaluatoriAll'
export default class SelecteazaUserRaport extends React.Component {
    constructor(props) {
        super(props);

        this.chartsClass = []
        this.state = {

        }
    }

    componentDidMount() {
    }








    u = new Utils()
    render() {
        return (
            <div>
                <Dialog
                    className="pm-alert-dialog"
                    disableEscapeKeyDown
                    open={this.props.open}
                    onClose={this.props.dialogClose}
                    style={{ zIndex: 6000 }}
                    maxWidth={'xs'}
                >

                    <DialogActions >
                        <Fab onClick={this.props.dialogClose}
                            className="pm-round-button-dialog"
                            style={{ boxShadow: 'none', backgroundColor: 'transparent' }}
                        >
                            <i style={{ color: 'black', fontSize: 28, fontWeight: 500 }} className='material-icons'>close</i>
                        </Fab>
                    </DialogActions>
                    <DialogContent>
                        <Grid container>
                            <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
                                <h2  >Selecteaza Persoanele Incluse In Raport </h2>
                            </Grid>

                            <Grid item>
                                <ListaEvaluatoriAll
                                    listaDepartamente={this.props.departamente}
                                    selecteazaDepartament={this.props.selecteazaDepartament}
                                    selecteazaAngajat={this.props.selecteazaAngajat}

                                />
                            </Grid>
                        </Grid>
                    </DialogContent>

                    <DialogActions style={{justifyContent:'flex-start'}}>
                        <Button style={{ padding: 10, backgroundColor: 'rgb(24 166 59)', color: 'white', fontWeight: 500 }} onClick={this.props.salveazaSiInchide}  >

                            Salveaza si inchide
                        </Button>
                    </DialogActions>

                </Dialog>
            </div >
        );
    }
}